import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {MercadoriasService} from "../mercadorias/mercadorias.service";
import {MercadoriasClassificacaoModel} from "./mercadorias-classificacao.model";
import {MercadoriasClassificacaoService} from "./mercadorias-classificacao.service";
import {MercadoriasDefeitosService} from "../mercadorias-defeitos/mercadorias-defeitos.service";


@Component({
  selector: 'app-mercadorias-classificacao-form',
  templateUrl: './mercadorias-classificacao-form.component.html'
})
export class MercadoriasClassificacaoFormComponent implements OnInit {

  enviandoForm = false;
  form: FormGroup;
  title: string;
  classificacao: MercadoriasClassificacaoModel = new MercadoriasClassificacaoModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  listMercadorias = [];
  listDefeitos = [];
  listCores = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private mercadoriasService: MercadoriasService,
    private mercadoriasClassificacaoService: MercadoriasClassificacaoService,
    private mercadoriasDefeitosService: MercadoriasDefeitosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      id_mercadoria: ['', [
        Validators.required
      ]],
      id_defeito: ['', [
        Validators.required,
        BasicValidators.diferenteZero
      ]],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      percentual: ['', [
        Validators.required
      ]],
      percentual_tipo: ['', [
        Validators.required
      ]],
      cor: ['', [
        Validators.required
      ]]
    });

    this.listCores = [{
      "nome": "Verde",
      "valor": 1
    },{
      "nome": "Amarelo",
      "valor": 2
    },{
      "nome": "Vermelho",
      "valor": 0
    }];
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop().substring(0,3) == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop().substring(0,3) == 'add'){
      this.pageIsAdd = true;
      this.classificacao.id_mercadoria = this.route.snapshot.queryParams["mercadoria"];
      this.carregaDefeitos();
      this.classificacao.id_defeito = this.route.snapshot.queryParams["defeito"];
    }

    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;

          if(this.global.debug == true){
            console.log('listMercadorias', json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.route.params.subscribe(params => {
      let id = params['id_classificacao'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarClassificacao');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarClassificacao') : this.func.traduzir('front.cadastrarNovaClassificacao');
      }

      if (!id) {
        return;
      }

      this.mercadoriasClassificacaoService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarClassificacao')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarClassificacao') + ': ' + json.Payload[0].nome;
            }
            this.classificacao = json.Payload[0];

            this.carregaDefeitos();

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    let result,

    //values = this.form.value;
      values = this.classificacao;

    this.enviandoForm = true;

    if (values.id) {
      result = this.mercadoriasClassificacaoService.editar(values, values.id);
    } else {
      result = this.mercadoriasClassificacaoService.adicionar(values);
    }

    result.subscribe(data => {
      if(this.route.snapshot.queryParams["mercadoria"] && this.route.snapshot.queryParams["defeito"]){
        this.router.navigate(['/painel', 'mercadorias', this.classificacao.id_mercadoria, 'upd'], { queryParams: { abaindices: '1' }});
      }else{
        this.router.navigate(['/painel', 'mercadorias', 'classificacao']);
      }

    },
      error => {
        let json = error.json();
        this.func.showErro(json);

        this.enviandoForm = false;

        for(let i in json.Message.ErrorInput){
          let erro = {};
          erro[i] = json.Message.ErrorInput[i];
          this.form.controls[i].setErrors(erro);
        }
      });
  }

  carregaDefeitos(){
    this.mercadoriasDefeitosService.get(null, {"id_mercadoria": this.classificacao.id_mercadoria})
      .subscribe(
        json => {
          this.listDefeitos = json.Payload;

          if(this.global.debug == true){
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  changeMercadoria(){
    this.classificacao.id_defeito = 0;
    this.carregaDefeitos();
  }
}



// WEBPACK FOOTER //
// ./src/app/mercadorias-classificacao/mercadorias-classificacao-form.component.ts